import { HoursByProjectAndEmployee } from '../../../api/api-types';
import { timeToDecimal } from '../../../utils/date-formatting';

export function calculateTotalHours(projects: HoursByProjectAndEmployee[]) {
  return projects
    .map((project) => timeToDecimal(project.countHours ?? ''))
    .reduce((a, b) => a + b, 0);
}
